// 屏幕适配 mixin 函数

// * 默认缩放值
const scale = {
  width: '1',
  height: '1',
}

// * 设计稿尺寸（px）
const baseWidth = 1920
const baseHeight = 1080

export default {
  data() {
    return {
      // * 定时函数
      drawTiming: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.calcRate()
    })
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
    if (this.drawTiming) {
      clearTimeout(this.drawTiming)
    }
  },
  methods: {
    calcRate () {
      const appRef = this.$refs["appRef"]
      if (!appRef) return 
      
      // 获取实际屏幕尺寸
      const clientWidth = window.innerWidth
      const clientHeight = window.innerHeight
      
      // 计算缩放比例（取较小的比例，保持宽高比）
      const scaleX = clientWidth / baseWidth
      const scaleY = clientHeight / baseHeight
      const scaleRatio = Math.min(scaleX, scaleY)
      
      // 保存缩放值
      scale.width = scaleRatio.toFixed(5)
      scale.height = scaleRatio.toFixed(5)
      
      // 应用缩放和居中定位
      appRef.style.transform = `scale(${scaleRatio})`
      appRef.style.transformOrigin = 'left top'
      
      // 计算居中偏移
      const scaledWidth = baseWidth * scaleRatio
      const scaledHeight = baseHeight * scaleRatio
      const left = (clientWidth - scaledWidth) / 2
      const top = (clientHeight - scaledHeight) / 2
      
      appRef.style.left = `${left}px`
      appRef.style.top = `${top}px`
    },
    resize () {
      clearTimeout(this.drawTiming)
      this.drawTiming = setTimeout(() => {
        this.calcRate()
      }, 200)
    }
  },
}